var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWord({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 77,
    height: 85,
    fill: "skyblue",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 277.8 375.74",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.23,375.74c-5.69-1.75-10.87-4.29-14.55-9.23C1.17,361.8,0,356.47,0,350.67c.07-26.54,0-53.07,0-79.61q0-122.9,0-245.8C0,15,3.71,7.07,13,2.54A25.89,25.89,0,0,1,24,.1q92.8-.21,185.63,0A6.58,6.58,0,0,1,213.89,2Q245.06,35.66,276,69.52a8.39,8.39,0,0,1,1.6,5.27q.12,102.36.07,204.71c0,22.5-.36,45,.13,67.5.3,13.75-3.76,24.07-19.32,28.74ZM258.4,85.09H210c-8.06,0-11.78-3.78-11.78-11.91q0-24.77,0-49.53V19.3H26.64c-6.7,0-7.34.64-7.34,7.3q0,161.24,0,322.48c0,6.73.62,7.36,7.27,7.36H251.09c6.7,0,7.31-.61,7.31-7.33v-264ZM246.11,65.5,217.7,34.64V65.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.75,128.34H56.21C49.51,102,42.85,75.75,36.13,49.27H50.81c4.22,18.08,8.44,36.13,12.85,55,.53-1.58.88-2.47,1.12-3.38C69,84.76,73.33,68.6,77.43,52.39c.68-2.66,1.78-3.57,4.46-3.38,3.16.23,6.34.05,10,.05,4.27,17.93,8.52,35.8,13,54.8,4.9-18.84,9.56-36.73,14.23-54.66h14a24.16,24.16,0,0,1-.46,2.88C125.84,76.5,118.85,100.9,112,125.34c-.69,2.46-1.63,3.46-4.22,3.24-3.27-.29-7.49,1-9.6-.63s-2.13-5.94-2.9-9.12q-5-20.82-10-41.66a2.76,2.76,0,0,0-1.12-1.74Q77,101.88,69.75,128.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141,160h87.68c6.25,0,9.9,2.81,9.79,7.43s-3.62,7.14-9.69,7.15H84.64c-10.4,0-20.79,0-31.18,0a16,16,0,0,1-4.69-.58,7,7,0,0,1-.09-13.3,18.12,18.12,0,0,1,5.41-.64Q97.56,160,141,160Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141,245.86h87.31c6.62,0,10.26,2.66,10.15,7.39s-3.66,7.17-10.06,7.17q-87.3,0-174.62,0a17.07,17.07,0,0,1-5-.62A6.42,6.42,0,0,1,44,253.16c0-3.26,1.52-5.69,4.67-6.69a17.12,17.12,0,0,1,5.06-.59Q97.38,245.83,141,245.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.13,303.84q-43.66,0-87.31,0a17.12,17.12,0,0,1-5.07-.53c-3.3-1-4.88-3.57-4.74-7a6.42,6.42,0,0,1,5-6.41,18.1,18.1,0,0,1,4.7-.55q87.5,0,175,0a18.37,18.37,0,0,1,3.63.33c3.76.77,6.24,3.7,6.16,7.11a7.38,7.38,0,0,1-6.77,7,32.07,32.07,0,0,1-3.67.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.43,217.42H54.11c-6.87,0-10.18-2.37-10.16-7.23S47.29,203,54.17,203H228.06c6.91,0,10.3,2.31,10.44,7.07S235,217.42,228,217.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.11,126.2c-14.06,0-28.11.06-42.16,0-6.45,0-10.24-5.27-7.66-10.4,1.63-3.24,4.59-4.15,8-4.16h80.65c.85,0,1.71,0,2.56,0,5.62.09,9.12,3,9,7.45s-3.51,7.11-8.95,7.12C215.72,126.22,201.92,126.2,188.11,126.2Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWord);
export default __webpack_public_path__ + "static/media/word.266990ee95e4b0ed5751f25b713db6e0.svg";
export { ForwardRef as ReactComponent };